import { render } from "./loading-modal.vue?vue&type=template&id=1901edc3"
import script from "./loading-modal.vue?vue&type=script&lang=js"
export * from "./loading-modal.vue?vue&type=script&lang=js"

import "./loading-modal.vue?vue&type=style&index=0&id=1901edc3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__